<template>
  <div
    :class="[
      $style.checkBoxRadioInput,
      disabled && $style.disabled,
      $style[align],
      $style[type]]"
  >
    <label
      :for="id"
      :class="$style.checkBoxContainer"
    >

      <slot v-if="align === 'right'">
        <span
          :class="[
            $style.label,
            correct && $style.correct,
            error && $style.error,
            passed && $style.passed]"
        >
          {{ label }}
        </span>
      </slot>

      <input
        v-if="type === 'checkbox'"
        :id="id"
        type="checkbox"
        :class="$style.input"
        :checked="value"
        :disabled="disabled"
        @change="$emit('update:value', $event.target.checked)"
      >

      <input
        v-else
        :id="id"
        type="radio"
        :class="$style.input"
        :name="radioGroupName"
        :checked="value === radioValue"
        :value="radioValue"
        :disabled="disabled"
        @change="$emit('update:value', $event.target.value)"
      >

      <div
        :class="[
          $style.checkBoxIndicator,
          correct && $style.correct,
          error && $style.error,
          passed && $style.passed]"
      />

      <slot v-if="align === 'left'">
        <span
          :class="[
            $style.label,
            correct && $style.correct,
            error && $style.error,
            passed && $style.passed]"
        >
          {{ label }}
        </span>
      </slot>

      <transition name="slide-fade">
        <Error v-if="error">
          {{ error }}
        </Error>
      </transition>
    </label>

    <input
      v-if="customInput"
      type="text"
      :class="$style.customInput"
      @input="$emit('update:customValue', $event.target.value)"
    >
  </div>
</template>

<style lang="scss" module>
@import '../../styles/06-components/_components.CheckBoxRadioInput.module.scss';
</style>

<script>
import Error from '../others/Error';

export default {
  components: {
    Error,
  },
  props: {
    id: {
      type: String,
      default: null,
    },
    label: {
      type: String,
      default: null,
    },
    value: {
      type: [Boolean, String],
      default: null,
    },
    align: {
      type: String,
      default: 'left',
      validator(value) {
        return ['left', 'right'].indexOf(value) !== -1;
      },
    },
    type: {
      value: String,
      default: 'checkbox',
      validator(value) {
        return ['checkbox', 'radio'].indexOf(value) !== -1;
      },
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    customInput: {
      type: Boolean,
      default: false,
    },
    customValue: {
      type: String,
      default: null,
    },
    radioGroupName: {
      type: String,
      required: false,
      default: '',
    },
    radioValue: {
      type: String,
      required: false,
      default: null,
    },
    passed: {
      type: Boolean,
      required: false,
    },
    error: {
      type: [Boolean, String],
      required: false,
      default: '',
    },
    correct: {
      type: Boolean,
      required: false,
    },
  },
};
</script>
